// Number of announcements added to the drawer per "Load more" click.
// The loader always fetches from skip 0 with limit = newsSkip + NEWS_PAGE_SIZE,
// so the server returns the whole accumulated list and the drawer can render
// locals.listNews directly instead of stitching pages together in component state.
export const NEWS_PAGE_SIZE = 10;

// Builds the loader args for a given `newsSkip` query param (the number of
// announcements already on screen).
export const getNewsLoaderArgs = (newsSkip) => ({
  skip: 0,
  limit: (Number.parseInt(newsSkip, 10) || 0) + NEWS_PAGE_SIZE,
});
